import { Alert, Body2, themeLight } from "@coherehealth/common";
// eslint-disable-next-line cohere-react/no-mui-styled-import
import { makeStyles, createStyles, Theme, styled } from "@material-ui/core/styles";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { CircularProgress } from "@mui/material";
import { FetchContinuationCaseAlertState } from "./caseCompletePageUtils";

export const useClinicalReviewStyles = makeStyles((theme: Theme) =>
  createStyles({
    body1: {
      color: themeLight.palette.text.secondary,
    },
    caption: {
      color: themeLight.palette.text.secondary,
    },
    secondaryButton: {
      width: theme.spacing(32),
      whiteSpace: "nowrap",
      marginLeft: theme.spacing(3),
    },
    primaryButton: {
      marginLeft: theme.spacing(3),
      width: theme.spacing(32),
    },
    primaryButtonFollowUp: {
      marginLeft: theme.spacing(3),
      width: theme.spacing(34),
    },
    outcomeCaseTrackingBox: {
      padding: theme.spacing(0, 5, 3, 2),
      margin: theme.spacing(0, 4.5, 0, 4.5),
    },
    divider: {
      paddingTop: "5vh",
      maxWidth: "1232px",
      width: "100%",
    },
    readyForClinicalReview: {
      width: "78%",
      padding: "8px 16px",
    },
    requestSubmittedGridPadding: {
      marginBottom: theme.spacing(3),
    },
  })
);
// eslint-disable-next-line cohere-react/no-mui-styled-import
export const PaddedAlert = styled(Alert)(({ theme }) => ({
  userSelect: "text",
  textAlign: "left",
  padding: theme.spacing(1, 2),
  width: "67%",
}));
export const fetchedAlertState: FetchContinuationCaseAlertState = {
  message: "This request is ready for clinical review.",
  startIcon: <AssignmentIcon />,
  buttonBody: <Body2>Begin clinical review</Body2>,
  buttonDisabled: false,
  state: "FETCHED",
};
export const timedOutAlertState: FetchContinuationCaseAlertState = {
  message: "This request will be ready for clinical review soon.",
  startIcon: <></>,
  buttonDisabled: true,
  buttonBody: <Body2 color="primary">The clinical review case could not be loaded.</Body2>,
  state: "TIMED_OUT",
};
export const loadingAlertState: FetchContinuationCaseAlertState = {
  message: "This request is ready for clinical review.",
  startIcon: <CircularProgress size="1.2rem" />,
  buttonDisabled: true,
  buttonBody: <Body2 color="primary">Loading the clinical review case</Body2>,
  state: "LOADING",
};
